/** A complete preference statement, not a style constraint on an action. */
export function chatStylePreference(message: string): string | null {
  const text = message.trim().replace(/^(?:actually|correction|remember)\s*[:,]?\s*/i, '');
  const match = /^(?:my\s+(?:preferred\s+)?style(?:\s+in\s+this\s+chat)?\s+is|i\s+prefer|(?:for\s+this\s+chat[,]?\s+)?(?:use|remember)\s+(?:my\s+)?(?:preferred\s+)?style\s*[:=]?)\s+([\w -]{1,60}?)(?:\s+style)?[.!]?(?:\s+(?:do\s+not|don['’]?t)\s+(?:generate|create|make|render|plan|start)\s+(?:anything|any\s+ads|ads|images|concepts|anything\s+yet)[.!]?)?$/i.exec(text);
  if (!match || /\b(?:make|create|generate|plan|build|ads|images|concepts|then|but|and)\b/i.test(match[1])) return null;
  return match[1].trim();
}

